import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  inputMode?: "text" | "email" | "tel" | "url" | "numeric" | "decimal" | "search";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputMode, ...props }, ref) => {
    // Auto-determine inputMode based on type if not specified
    const determinedInputMode = inputMode || (
      type === "email" ? "email" :
      type === "tel" ? "tel" :
      type === "url" ? "url" :
      type === "number" ? "numeric" :
      type === "search" ? "search" :
      undefined
    );

    return (
      <input
        type={type}
        inputMode={determinedInputMode}
        className={cn(
          // Atrium input: generous rounded, hairline border, primary-tinted focus
          "flex h-12 w-full rounded-xl border border-foreground/12 bg-background px-4 py-2.5 ring-offset-background transition-all duration-200",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground/70",
          "hover:border-foreground/20",
          "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-4 focus-visible:ring-primary/12",
          "disabled:cursor-not-allowed disabled:opacity-50",
          // Mobile-optimized: 16px prevents iOS zoom
          "text-[16px]",
          // Desktop: smaller text
          "md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
